import { GoogleOptimizeExperimentData, GoogleOptimizeExperiment } from "./google_optimize_experiment";

interface IExperimentConfig {
  experiment_name: string;
  pattern_name: string;
}

export class GoogleOptimize {
  public static init(): void {
    new GoogleOptimize().init();
    // Google OptimizeのJSがこれより後ろ実行される場合pushをfunctionとして扱う
    window.googleOptimize = window.googleOptimize || {};
    window.googleOptimize.experiments = window.googleOptimize.experiments || [];
    window.googleOptimize.experiments.push = (config: IExperimentConfig): void => {
      const experimentData = new GoogleOptimizeExperimentData(config.experiment_name, config.pattern_name);
      new GoogleOptimizeExperiment(experimentData).init();
    };
  }

  public init(): void {
    this.getExperiments().forEach((experiment) => {
       experiment.init();
    });
  }

  private getExperiments(): Array<GoogleOptimizeExperiment> {
    if(window.googleOptimize === undefined) {
      return [];
    }

    if(window.googleOptimize.experiments === undefined) {
      return [];
    }

    return window.googleOptimize.experiments.map((element: IExperimentConfig) => {
      const experimentData = new GoogleOptimizeExperimentData(element.experiment_name, element.pattern_name);
      return new GoogleOptimizeExperiment(experimentData);
    });
  }
}
